/**
 * @generated SignedSource<<38b9bf50c1275b94eb191222c7febab4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopicCommentsNewCommentSubscription$variables = {
  topicId: string;
};
export type TopicCommentsNewCommentSubscription$data = {
  readonly newComments: {
    readonly hotness: number;
    readonly node: {
      readonly id: string;
      readonly parent: {
        readonly id: string;
      } | null | undefined;
      readonly topic: {
        readonly id: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"CommentFragment">;
    };
  };
};
export type TopicCommentsNewCommentSubscription = {
  response: TopicCommentsNewCommentSubscription$data;
  variables: TopicCommentsNewCommentSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topicId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "topicId",
    "variableName": "topicId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hotness",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*:: as any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": (v4/*:: as any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Forum",
  "kind": "LinkedField",
  "name": "forum",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v6/*:: as any*/),
        (v3/*:: as any*/)
      ],
      "storageKey": null
    },
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": "viewerCanDelete",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "DELETE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"DELETE_COMMENT\")"
},
v9 = {
  "alias": "viewerCanUpdate",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_COMMENT\")"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edited",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    (v13/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*:: as any*/),
        (v15/*:: as any*/)
      ],
      "type": "Entity",
      "abstractKey": "__isEntity"
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": "viewerCanReply",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_COMMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_COMMENT\")"
},
v18 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v19 = [
  (v18/*:: as any*/),
  {
    "kind": "Literal",
    "name": "order",
    "value": "HOT"
  }
],
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voterCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v18/*:: as any*/)
      ],
      "concreteType": "VotersConnection",
      "kind": "LinkedField",
      "name": "voters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EntityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v6/*:: as any*/),
                (v13/*:: as any*/),
                {
                  "kind": "TypeDiscriminator",
                  "abstractKey": "__isEntity"
                },
                (v14/*:: as any*/),
                (v15/*:: as any*/),
                (v3/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "voters(first:10)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EntityVote",
      "kind": "LinkedField",
      "name": "voted",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "score",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanVote",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "PUBLISH_VOTE"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"PUBLISH_VOTE\")"
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicCommentsNewCommentSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "newComments",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": (v4/*:: as any*/),
                "storageKey": null
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "bottomLevel",
                    "value": true
                  }
                ],
                "kind": "FragmentSpread",
                "name": "CommentFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "TopicCommentsNewCommentSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CommentEdge",
        "kind": "LinkedField",
        "name": "newComments",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              },
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              {
                "alias": null,
                "args": (v19/*:: as any*/),
                "concreteType": "CommentConnection",
                "kind": "LinkedField",
                "name": "children",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v8/*:: as any*/),
                          (v9/*:: as any*/),
                          (v10/*:: as any*/),
                          (v11/*:: as any*/),
                          (v12/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topic",
                            "plural": false,
                            "selections": [
                              (v7/*:: as any*/),
                              (v3/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*:: as any*/),
                          (v16/*:: as any*/),
                          (v17/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numChildren",
                            "storageKey": null
                          },
                          (v6/*:: as any*/),
                          (v20/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "children(first:10,order:\"HOT\")"
              },
              {
                "alias": null,
                "args": (v19/*:: as any*/),
                "filters": [
                  "order"
                ],
                "handle": "connection",
                "key": "CommentCommentsFragment_children",
                "kind": "LinkedHandle",
                "name": "children"
              },
              (v20/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "88b04ef0aa98bea8cbf9d372ed7dbabe",
    "id": null,
    "metadata": {},
    "name": "TopicCommentsNewCommentSubscription",
    "operationKind": "subscription",
    "text": "subscription TopicCommentsNewCommentSubscription(\n  $topicId: ID!\n) {\n  newComments(topicId: $topicId) {\n    hotness\n    node {\n      id\n      parent {\n        id\n      }\n      topic {\n        id\n      }\n      ...CommentFragment_70TG5\n    }\n  }\n}\n\nfragment CommentCommentsFragment_1jcI8F on Comment {\n  children(first: 10, order: HOT) {\n    edges {\n      cursor\n      hotness\n      node {\n        id\n        ...CommentFragment_4swzNU\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment CommentDeleteFragment on Comment {\n  id\n  author {\n    id\n  }\n  topic {\n    id\n  }\n  parent {\n    id\n  }\n}\n\nfragment CommentDisplayFragment on Comment {\n  viewerCanDelete: viewerCan(action: DELETE_COMMENT)\n  viewerCanUpdate: viewerCan(action: UPDATE_COMMENT)\n  id\n  content\n  edited\n  createdAt\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n  parent {\n    id\n  }\n  ...CommentDeleteFragment\n  author {\n    id\n    username\n    ...EntityProfilePicFragment_49kWkb\n  }\n  ...VoteDisplayFragment\n}\n\nfragment CommentFragment_4swzNU on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  numChildren\n}\n\nfragment CommentFragment_70TG5 on Comment {\n  id\n  ...CommentDisplayFragment\n  ...CommentReplyFragment\n  ...CommentCommentsFragment_1jcI8F\n}\n\nfragment CommentReplyFragment on Comment {\n  id\n  viewerCanReply: viewerCan(action: CREATE_COMMENT)\n  topic {\n    forum {\n      owner {\n        __typename\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EntitiesAvatarFragment on VotersConnection {\n  edges {\n    node {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment VoteDisplayFragment on Votable {\n  __isVotable: __typename\n  id\n  votes\n  voterCount\n  voters(first: 10) {\n    ...EntitiesAvatarFragment\n  }\n  voted @ifAllowed {\n    score\n  }\n  viewerCanVote: viewerCan(action: PUBLISH_VOTE)\n}\n"
  }
};
})();

(node as any).hash = "25e9b6113d177bd0ba98e4cf6f87fec2";

export default node;
